export default "/Finish.glb";